/**
 * @generated SignedSource<<30bfe6ff581af4da9b8d56ace672fbd0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleContentVariant_viewer" | "HpSharedFeaturedModuleContent_viewer">;
  readonly " $fragmentType": "HpSharedFeaturedModule_viewer";
};
export type HpSharedFeaturedModule_viewer$key = {
  readonly " $data"?: HpSharedFeaturedModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isHpSaleModuleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModule_viewer",
  "selections": [
    {
      "condition": "isHpSaleModuleVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModuleContent_viewer"
        }
      ]
    },
    {
      "condition": "isHpSaleModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModuleContentVariant_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "78669b5e1b4fea8afcc81fb8185434b4";

export default node;
